import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { useField } from 'react-final-form';
import { Label, LabelText, Input as Input$2, ErrorText } from '../Form.styles.js';

var _excluded = ["name", "label", "type", "validations", "placeholderText"];
var Input = function Input(_ref) {
  var name = _ref.name,
    label = _ref.label,
    type = _ref.type,
    _ref$validations = _ref.validations,
    validations = _ref$validations === void 0 ? null : _ref$validations,
    _ref$placeholderText = _ref.placeholderText,
    placeholderText = _ref$placeholderText === void 0 ? null : _ref$placeholderText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useField = useField(name, {
      validate: validations
    }),
    input = _useField.input,
    meta = _useField.meta;
  return /*#__PURE__*/React.createElement(Label, {
    gridArea: name
  }, /*#__PURE__*/React.createElement(LabelText, {
    className: "label input-label"
  }, label), /*#__PURE__*/React.createElement(Input$2, _extends({}, input, rest, {
    type: type,
    hasError: Boolean(meta.touched && meta.error),
    isTouchedAndValid: Boolean(meta.touched && !meta.error),
    "aria-invalid": Boolean(meta.touched && meta.error),
    placeholder: placeholderText
  })), meta.error && meta.touched && /*#__PURE__*/React.createElement(ErrorText, {
    className: "error-text"
  }, meta.error));
};
var Input$1 = Input;

export { Input$1 as default };
//# sourceMappingURL=Input.js.map
